import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

interface AgentV2UserStatsOverviewResponse {
  total_users: number;
  yesterday_unique_users: number;
  yesterday_unique_growth_rate: number;
  total_users_growth_rate: number;
  total_generation_count: number;
  total_generation_growth_rate: number;
  yesterday_generation_count: number;
  generation_growth_rate: number;
  average_generation_per_user: number;
  average_generation_per_user_growth_rate: number;
}

export class AgentV2UserStatsOverviewData {
  @Required("Total users cannot be empty")
  @IsNumber("Total users must be a number")
  totalUsers: number;

  @Required("Yesterday unique users cannot be empty")
  @IsNumber("Yesterday unique users must be a number")
  yesterdayUniqueUsers: number;

  @Required("Yesterday unique users growth rate cannot be empty")
  @IsNumber("Yesterday unique users growth rate must be a number")
  yesterdayUniqueGrowthRate: number;

  @Required("Total users growth rate cannot be empty")
  @IsNumber("Total users growth rate must be a number")
  totalUsersGrowthRate: number;

  @Required("Total generation count cannot be empty")
  @IsNumber("Total generation count must be a number")
  totalGenerationCount: number;

  @Required("Total generation growth rate cannot be empty")
  @IsNumber("Total generation growth rate must be a number")
  totalGenerationGrowthRate: number;

  @Required("Yesterday generation count cannot be empty")
  @IsNumber("Yesterday generation count must be a number")
  yesterdayGenerationCount: number;

  @Required("Generation growth rate cannot be empty")
  @IsNumber("Generation growth rate must be a number")
  generationGrowthRate: number;

  @Required("Average generation per user cannot be empty")
  @IsNumber("Average generation per user must be a number")
  averageGenerationPerUser: number;

  @Required("Average generation per user growth rate cannot be empty")
  @IsNumber("Average generation per user growth rate must be a number")
  averageGenerationPerUserGrowthRate: number;
}

const transformAndValidateData = (
  response: AgentV2UserStatsOverviewResponse
): AgentV2UserStatsOverviewData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2UserStatsOverviewData);
  } catch (error) {
    console.error("Agent v2 user stats overview data validation failed:", error.message);
    throw error;
  }
};

/** 内容管理-数据概览 */
export const agentV2UserStatsOverview = async (agentId: string) => {
  const res = await api.post<AgentV2UserStatsOverviewResponse>('/agent-v2/user-stats/overview', {
    agent_id: agentId,
  });
  const data = transformAndValidateData(res.data);
  return data;
}